import React, { useEffect, useState } from 'react'
import { useAdminStudentList, useCourseList } from '../../assets/api/useAdminApi';
import { useMutation } from '@tanstack/react-query';
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
// import api from '../../assets/api/useStudentPostApi';
import { Button, Grid2 } from '@mui/material';
import { DateFormField } from '../../shared/components/formfields/DataFormField';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import CustomDivider from '../../shared/utils/CustomDivider';
import { Grid_Gap } from '../../shared/constants';
import { useCourseApartmentList, usePriceCourseDetail } from '../../assets/api/UseStudentGetApi';
import { useToaster } from '../../shared/utils/ToasterProvider';
import useAuthStore from '../../store/useAuthStore';
import api from '../../assets/nodeApi/axiosInstance';

const CreateOrderForm = () => {
    const { token } = useAuthStore()
    const { showToaster } = useToaster();
    const [course, setCourse] = useState({})
    const [apartment, setApartment] = useState({})
    const [student, setStudent] = useState({})
    const { data: courseList, isLoading } = useCourseList();
    const CoursesOptions = courseList?.data
        ?.filter(course => course?.status == 1)
        ?.map(course => ({
            id: course?.id,
            label: course?.title,
            value: course?.title,
            ...course
        })) || [];
    const { data: coursesApartmentList, isLoading: isLoadingApartmentList } = useCourseApartmentList({ "course_id": course?.id });
    const apartmentOptions = coursesApartmentList?.data?.map((apartment) => ({
        id: apartment?.id,
        label: apartment?.apartment_name,
        value: apartment?.apartment_name,
    })) || []
    const { data: studentlist, isLoading: isStudentLoading } = useAdminStudentList()
    const studentOption = studentlist?.data?.map((item, index) => ({
        id: item?.id,
        label: item?.lastname,
        value: item?.lastname,
    })) || []

    const { data: coursePriceDetail, isLoading: isPriceDetailIsLoading } = usePriceCourseDetail({
        apartmentName: apartment?.value,
        title: course?.value
    });

    const SyncPriceField = ({ price, setFieldValue, values }) => {
        // useEffect(() => {
        //     setFieldValue("price", coursePriceDetail?.data?.course_fees);
        // }, [coursePriceDetail]);


        useEffect(() => {
            // Only set price from API if course is NOT online
            if (!course?.online) {
                setFieldValue("price", coursePriceDetail?.data?.course_fees || "");
            }
        }, [coursePriceDetail, course]);


        return (
            <Field
                name="price"
                component={TextFormField}
                label="Price"
                type="number"
                disabled={true}
                isRequired={true}
            />
        );
    };

    const validationSchema = Yup.object().shape({
        user_id: Yup.string().required('Student is required'),
        event_id: Yup.string().required('Event is required'),
        apartments_id: Yup.string().when("event_id", {
            is: () => !course?.online,
            then: schema => schema.required("Apartment is required"),
            otherwise: schema => schema.notRequired(),
        }),
         price: Yup.number()
            .typeError('Price must be a number')
            .required('Price is required'),
        razorpay_order_id: Yup.string().required('Transaction ID is required'),
        created_at: Yup.date()
            .nullable()
            .required('Order Date is required'),
    });
    const initialValues = {
        user_id: '',
        event_id: '',
        price: '',
        razorpay_order_id: '',
        created_at: null,
    };

    const mutation = useMutation({
        mutationFn: (formData) => api.post("manual-orders", formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ),
    });
    const selectedStudent = studentlist?.data?.find(s => s.id === student?.id);
    const handleSubmit = (values, { setSubmitting, resetForm, setFieldError }) => {
        
        const ojb = {
            ...values,
            quantity: 1,
            price: values?.price,
            details: [
                {
                    "firstname": selectedStudent?.firstname,
                    "lastname": selectedStudent?.lastname,
                    "email": selectedStudent?.email
                }
            ]

        }
        mutation.mutate(ojb, {
            onSuccess: (response) => {
                if (response?.data?.success) {
                    showToaster('Success', response?.data?.message, 'success')
                    setStudent({})
                    setApartment({})
                    setCourse({})

                } else {
                    showToaster('Error', "Failed to Create Order", 'error')
                }
                resetForm({
                    values: {
                        ...initialValues,
                        price: "",
                    },
                });
            },
            onError: (error) => {
                if (!error?.response?.data?.success) {
                    showToaster(error?.response?.data?.message, "", 'error')
                    // setFieldError("razorpay_order_id", error?.response?.data?.message || "This Razorpay Order ID already exists")
                } else {
                    showToaster('Failed to Create Order', "", 'error')
                }

            },
            onSettled: () => {
                setSubmitting(false);
            },
        });


    }
    return (

        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ resetForm, setFieldValue, values }) => (
                    <Form>
                        <Grid2 container spacing={Grid_Gap}>
                            <Grid2 children size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="user_id"
                                    component={IdAutoCompleteField}
                                    noOptionsText={"Currently Unavailable"}
                                    options={studentOption}
                                    label="Select Student"
                                    isRequired={true}
                                    isLoading={isStudentLoading}
                                    // onClose={()=>setStudent({})}
                                    onValueChange={(e) => {
                                        setStudent(e)

                                    }}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="event_id"
                                    component={IdAutoCompleteField}
                                    options={CoursesOptions}
                                    noOptionsText={"Currently Unavailable"}
                                    label="Course"
                                    isRequired={true}
                                    isLoading={isLoading}
                                    // onClose={()=>setCourse({})}
                                    onValueChange={(e) => {
                                        setCourse(e)
                                        if (e?.online) {
                                            setFieldValue("price", e.price);
                                            setApartment({});                 // clear apartment
                                            setFieldValue("apartments_id", ""); // reset form field
                                        } else {
                                            setFieldValue("price", "");       // reset price for offline
                                        }

                                    }}
                                />
                            </Grid2>
                            {!course?.online &&
                                <Grid2 children size={{ xs: 12, sm: 4 }}>
                                    <Field
                                        name="apartments_id"
                                        component={IdAutoCompleteField}
                                        noOptionsText={"Currently Unavailable"}
                                        options={apartmentOptions}
                                        label="Apartment"
                                        isRequired={true}
                                        isLoading={isLoadingApartmentList}
                                        onValueChange={(e) => {
                                            setApartment(e);
                                        }}
                                    />
                                </Grid2>
                            }
                            <Grid2 children size={{ xs: 12, sm: 4 }}>
                                {/* <Field
                                    name="price"
                                    component={TextFormField}
                                    label="Price"
                                    isRequired={true}
                                    value={coursePriceDetail?.data?.course_fees}
                                    type="number"
                                    disabled={true}
                                /> */}

                                <SyncPriceField
                                    price={initialValues.price}
                                    setFieldValue={setFieldValue}
                                    values={values}
                                />

                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="razorpay_order_id"
                                    component={TextFormField}
                                    label="Transaction Id"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 4 }}>
                                <Field
                                    name="created_at"
                                    component={DateFormField}
                                    label="Order Date"
                                    isRequired={true}
                                    minDate={new Date(new Date().setDate(new Date().getDate() - 7))}
                                />
                            </Grid2>
                        </Grid2>
                        <CustomDivider />
                        <Grid2 container spacing={Grid_Gap} sx={{ display: "flex", justifyContent: "end" }}>
                            <Grid2 children size={{ xs: 12, sm: 3 }}>
                                <Button variant='outlined' fullWidth onClick={resetForm}>Cancel</Button>
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 3 }}>
                                <Button variant='contained' type="submit" fullWidth>Submit</Button>
                            </Grid2>
                        </Grid2>

                    </Form>
                )}
            </Formik>
        </>
    )
}

export default CreateOrderForm